import { IconType } from 'react-icons';
import { FaStar, FaCircleInfo, FaImage, FaGamepad, FaBriefcase, FaLink } from 'react-icons/fa6';
import { VscActivateBreakpoints } from "react-icons/vsc";

// メニュー項目の型定義
export interface MenuItem {
  path: string;
  label: string;
  icon?: IconType; // コンポーネントそのものを受け取る型に変更
}

// メニュー項目の配列（ここを編集するだけで簡単に追加・削除可能）
export const menuItems: MenuItem[] = [
  { path: '/', label: 'Top', icon: FaStar },
  { path: '/about', label: 'About', icon: FaCircleInfo },
  { path: '/gallery', label: 'Gallery', icon: FaImage },
  { path: '/character', label: 'Character', icon: VscActivateBreakpoints },
  { path: '/software', label: 'Software', icon: FaGamepad},
  { path: '/works', label: 'Works', icon: FaBriefcase },
  { path: '/links', label: 'Links', icon: FaLink },

  // 新しいページを追加する場合は、ここに追加するだけ
  // { path: '/works', label: 'Works' },
  // { path: '/contact', label: 'Contact' },
];
